.container {
  display: flex;
  flex-direction: row;
  column-gap: 8rem;
}

.column {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.icon {
  color: var(--color-icon--meal);
}

.title {
  display: flex;
  align-items: center;
  margin-bottom: 2.4rem;
}

.title > svg {
  margin-right: 2rem;
}

.link {
  margin-top: 1rem;
}
